<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Patient Management</h1>
        </div>
        <div class="content-section">
            <div class="outer-box">
                <div class="global-table no-radius p0">
                    <div class="tab-content1">
                        <div class="tab-pane1">
                            <div class="sec_head_new sec_head_new_after">
                                <form [formGroup]="searchForm">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="filter_search mb20 width100">
                                                <div class="input-group filter_search_group">
                                                    <input type="text" class="form-control overflow-text"
                                                        formControlName="search" placeholder="Search by name"
                                                        maxlength="60">
                                                    <div class="input-group-append">
                                                        <button class="btn btn_search_group" type="button"
                                                            (click)="PatientListApi()">
                                                            <img src="assets/img/icon-search.png" alt="Search"
                                                                (error)="onImageError($event)">
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">

                                        </div>
                                        <div class="col-md-5">
                                            <div class="form-group row d-flex justify-content-end">
                                                <div class="ms-5 text-align-end text-nowrap" style="text-align: end">
                                                    <button type="button" (click)="exportCsv()"
                                                        class="btn btn-info link font17 me-3"
                                                        style="height: 35px;padding-top: 3px;">
                                                        <i class="fa fa-download" aria-hidden="true"> Download Report
                                                        </i>
                                                    </button>
                                                    <button type="button" routerLink="/add-patient"
                                                        class="btn btn-info link font17"
                                                        style="height: 35px;padding-top: 3px;">
                                                        <i class="fa fa-plus-circle" aria-hidden="true"> Add New </i>
                                                    </button>
                                                    <!-- <a class="link font17"><i class="fas fa-plus-circle me-1"></i> Add Sub Admin</a> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <mat-form-field appearance="fill" class="width-webkit-fill-available">
                                                <mat-label>From date:</mat-label>
                                                <input matInput [max]="maxDate" id="fromDate" [matDatepicker]="picker"
                                                    formControlName="fromDate">
                                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                            </mat-form-field>
                                            <!-- <input type="date" id="fromDate" style="border-radius: 5px;max-width: 200px" class="form-control" formControlName="fromDate"> -->
                                        </div>
                                        <div class="col-md-2">
                                            <mat-form-field appearance="fill" class="width-webkit-fill-available">
                                                <mat-label>To Date :</mat-label>
                                                <input matInput [max]="maxDate" id="toDate" [matDatepicker]="picker1"
                                                    formControlName="toDate">
                                                <mat-datepicker-toggle matSuffix
                                                    [for]="picker1"></mat-datepicker-toggle>
                                                <mat-datepicker #picker1></mat-datepicker>
                                            </mat-form-field>
                                            <!-- <input type="date" id="toDate" style="border-radius: 5px;max-width: 200px" class="form-control" formControlName="toDate"> -->

                                        </div>
                                        <div class="col-md-8">
                                            <button type="button" class="btn btn-info" (click)="PatientListApi()"
                                                style="height: 35px;padding-top: 3px;">
                                                <i class="fa fa-search"> Search </i>
                                            </button>

                                            <button class="btn btn-danger ms-2" type="button" (click)="Reset()"
                                                style="height: 35px;padding-top: 3px;">
                                                <i class="fa fa-undo"> Reset</i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered" aria-describedby="">
                                <thead>
                                    <tr class="no_wrap_th text-center">
                                        <th class="Sorting-img" scope="col">S.No.</th>
                                        <th scope="col" class="Sorting-img">Patient name</th>
                                        <th scope="col" class="Sorting-img">Email address</th>
                                        <th scope="col" class="Sorting-img">Date of joining</th>
                                        <th scope="col" class="Sorting-img">Therapist Name</th>
                                        <th scope="col" class="Sorting-img">Program</th>

                                        <th scope="col" class="action_td_btn3 Sorting-img">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (pat of patientList | paginate: { itemsPerPage: itemPerPage, currentPage:
                                    currentPage, totalItems: total }; track pat?._id; let i = $index ) {
                                    <tr class="text-center">
                                        <td class="content">{{ itemPerPage * (currentPage - 1) + i + 1 }}</td>

                                        <td class="content">{{ pat?.firstName }} {{ pat?.lastName }}</td>

                                        <td class="content">
                                            <abbr [title]="pat?.email">{{ pat?.email }}</abbr>
                                        </td>

                                        <td class="content">{{ pat?.createdAt | date: 'd/M/y' : 'UTC' }}</td>

                                        <td class="content">
                                            @if (!pat?.myTherapist[0]) {
                                            <button type="button" (click)="editProgram(pat?._id, '')"
                                                class="btn btn-secondary">
                                                Not assigned
                                            </button>
                                            }
                                            @if (pat?.myTherapist[0]) {
                                            <span>{{ pat.myTherapist[0].firstName }} {{ pat.myTherapist[0].lastName
                                                }}</span>
                                            }
                                        </td>

                                        <td class="content">
                                            @if (!pat?.programSubscription?.title) {
                                            <button type="button" (click)="editProgram(pat?._id, 'notAssign')"
                                                class="btn btn-secondary">
                                                Not assigned
                                            </button>
                                            }
                                            @if (pat?.programSubscription?.title) {
                                            <span>{{ pat.programSubscription.title || '--' }}</span>
                                            }
                                        </td>

                                        <td class="text-center action_td">
                                            <button class="btn btn-info ms-2 bt-margin" title="view"
                                                (click)="viewProgram(pat?._id, pat?.myTherapist[0]?._id)">
                                                <i class="fa fa-eye" style="color:white"></i>
                                            </button>

                                            <button class="btn btn-info ms-2 bt-margin"
                                                (click)="editProgram(pat?._id, '')">
                                                <i class="fa fa-edit" style="color:white"></i>
                                            </button>

                                            <button class="btn btn-danger ms-2 bt-margin" title="delete"
                                                (click)="deleteUserModal(pat?._id)">
                                                <i class="fa fa-trash" style="color:white"></i>
                                            </button>

                                            <label class="switch" (click)="openActiveBlock(pat?.status, pat?._id)">
                                                <input type="checkbox" [checked]="pat?.status === 'ACTIVE'" />
                                                <span class="slider round"></span>
                                            </label>
                                        </td>
                                    </tr>
                                    }


                                    @if(!patientList.length){
                                    <tr>
                                        <td class="table-no-record" colspan="7">No Record Found</td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                            @if(total > 10){
                            <div class="custom-pagination mt-3 d-flex justify-content-end">
                                <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>

<!-- delete hospital modal Start -->
<div class="modal fade global-modal reset-modal" id="deleteUser">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    <h5 class="modal-title d-inline-block">Delete Patient?</h5>
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                <p>Are you sure you want to delete this patient?</p>
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme"
                                        (click)="deletePatientApi()">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px;"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- end delete hospital modal -->

<!-- ----------------  Active and block patient modal ----------------------- -->

<div class="modal fade global-modal reset-modal" id="actBlockStatus">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    @if(patientStatus == 'ACTIVE'){
                    <h5 class="modal-title d-inline-block">Block Patient?</h5>
                    }
                    @else if(patientStatus == 'BLOCK'){
                    <h5 class="modal-title d-inline-block"> Active Patient?</h5>
                    }
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                @if(patientStatus == 'ACTIVE'){
                                <p>Are you sure you want to block this Patient?</p>
                                }
                                @else if(patientStatus == 'BLOCK'){
                                <p>Are you sure you want to Active this Patient?</p>
                                }
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme"
                                        (click)="updateActiveBlock()">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px;"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>